import { Component, inject } from '@angular/core';

import { profile } from '../../../../data/header';
import { FeatherIconComponent } from "../../../ui/feather-icon/feather-icon.component";
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-profile',
  imports: [FeatherIconComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})

export class ProfileComponent {

  public profile = profile;
  private readonly authService = inject(AuthService);

  get displayName(): string {
    return this.authService.getDisplayName();
  }

  get displayRole(): string {
    return this.authService.getDisplayRole();
  }

  onLogout(): void {
    this.authService.logout();
  }

}
